import React, { useEffect, useState } from 'react';
import { CustomButton } from '../Button/Button';
import Icon from '../Icon/Icon';
import styles from './SpoilerButton.module.scss';
import cx from 'classnames';

const SpoilerButton = ({ label, icon, children, disabled, index, mini, onClick }) => {
  const [showContent, setShowContent] = useState();

  useEffect(() => {
    mini && setShowContent(false);
  }, [mini]);

  const handleShowContent = () => {
    setShowContent(prevState => !prevState);
    if (mini) {
      onClick && onClick();
    }
  };

  useEffect(() => {
    disabled && setShowContent(false);
  }, [disabled]);

  return (
    <div
      className={cx(styles.optionContainer, { [styles.showArrowContent]: showContent && !mini, [styles.miniContainer]: mini })}
      style={{ zIndex: index }}
    >
      <CustomButton
        variant="link"
        onClick={handleShowContent}
        className={cx(styles.controlsBtn, styles.arrowButtonContainer)}
        disabled={disabled}
        mini={mini}
        ariaLabel={mini && label}
      >
        <div>
          <Icon src={icon} className={cx(styles.btnIcon, { [styles.btnIconMini]: mini })} />
          {!mini && <span>{label}</span>}
        </div>
        <div>
          <Icon src="showHideArrow" className={cx(styles.arrowButton, { [styles.turn]: showContent })} />
        </div>
      </CustomButton>
      {children}
    </div>
  );
};

export default SpoilerButton;
